import i18next from "i18next";
import { initReactI18next } from "react-i18next";

// 导入翻译资源
import zhCNTranslation from "./locales/zh-CN/translation.json";
import enUSTranslation from "./locales/en-US/translation.json";



// 语言配置常量
const LANGUAGE_CONFIG = {
  // 支持的语言列表
  SUPPORTED_LANGUAGES: ["zh-CN", "en-US"],
  // 默认语言
  DEFAULT_LANGUAGE: "zh-CN",
  // 语言映射（Redux状态 ↔ i18n语言代码）
  LANGUAGE_MAP: {
    "zhCN": "zh-CN",
    "enUS": "en-US",
    "zh-CN": "zhCN",
    "en-US": "enUS"
  }
};

// 简单的i18n配置
const i18nConfig = {
  lng: "zh-CN",
  fallbackLng: "zh-CN",
  debug: true,
  resources: {
    "zh-CN": {
      translation: zhCNTranslation
    },
    "en-US": {
      translation: enUSTranslation
    }
  },
  interpolation: {
    escapeValue: false,
  }
};

// 直接初始化i18n
const initResult = i18next
  .use(initReactI18next)
  .init(i18nConfig);

const i18nInitPromise = initResult
  .then(() => {
    // i18n初始化成功
    return true;
  })
  .catch((error) => {
    console.error("i18n初始化失败:", error);
    throw error;
  });

export { LANGUAGE_CONFIG, i18nInitPromise };
export default i18next;
